export default __webpack_public_path__ + "static/media/cn.bbe46ba6.png";